import { CircularProgress } from "@mui/material";
import React, { useState } from "react";
import { InputText, SubmitBtn } from "../../../Payment/Payment.styles";
import { CouponError, DiscountForm, DiscountWrapper } from "./DiscountCoupon.styles";
import { DiscountCouponPropsInterface } from "./models/discount-coupon-props.interface";
import couponService from "./services/coupon.service";

const DiscountCounpon = (props: DiscountCouponPropsInterface) => {
  const { changePrice, changeCouponState } = props;

  const [couponCode, setCouponCode] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [couponSuccess, setCouponSuccess] = useState(false);

  const handleChange = (e: any) => {
    const { value } = e.target;
    setCouponCode(value);
  };

  const validateCoupon = () => {
    setLoading(true);

    couponService.validate(couponCode)
      .then((result) => {
        const { data } = result;
        localStorage.setItem('coupon', couponCode);
        changePrice(data.amount);
        changeCouponState(true);
        setCouponSuccess(true);
        setError('');
      })
      .catch((err) => {
        setError('Cupom inválido');
      })
      .finally(() => { setLoading(false); });
  }

  const getInputBorderStyle = (): string => {
    if (couponSuccess) return 'inputSucess';

    else if (couponCode && error) {
      return 'inputError';
    }

    return '';
  }

  return (
    <DiscountWrapper>
      <span>Cupom de desconto</span>
      <DiscountForm>
        <InputText
          type="text"
          name="coupon"
          placeholder="Código"
          onChange={handleChange}
          className={getInputBorderStyle()}
        />
        <SubmitBtn
          type="button"
          disabled={!couponCode || loading}
          onClick={() => { validateCoupon() }}
        >
          {!loading && (
            <span>Aplicar</span>
          )}
          {loading && (
            <CircularProgress sx={{ color: "#FFF !important", width: "25px !important", height: "25px !important" }}/>
          )}
        </SubmitBtn>
      </DiscountForm>
      {error && (
        <CouponError>
          {error}
        </CouponError>
      )}
    </DiscountWrapper>
  );
};

export default DiscountCounpon;
